import React from "react";
import { Tooltip } from "@mui/material";
import { ImSpades } from "react-icons/im";

const OfflineMessage = ({ isSubscribed, isOffline, theme }) => {
  if (isSubscribed === "free" && isOffline) {
    return (
      <Tooltip title="Upgrade to Premium to Access" arrow>
        <div
          style={{
            position: "fixed",
            top: 0,
            left: "298px",
            right: 0,
            bottom: 0,
            background: isSubscribed !== "free" ? theme.button : "#d3d3d3",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            pointerEvents: "all",
            cursor: isSubscribed === "free" ? "not-allowed" : "pointer",
          }}
        >
          <div
            style={{
              background: "white",
              padding: "20px 30px",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              pointerEvents: "none",
            }}
          >
            <span
              style={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#333",
                marginRight: "8px",
              }}
            >
              Upgrade to Premium to access offline features or go online.
            </span>
            {isSubscribed === "free" && (
              <ImSpades
                style={{
                  color: "gold",
                  fontSize: "20px",
                  marginLeft: "10px",
                }}
              />
            )}
          </div>
        </div>
      </Tooltip>
    );
  }
  return null;
};

export default OfflineMessage;
